import React, { useEffect, useState } from "react";
import AgencySideBar from "../Components/AgencySideBar";
import Navbar from "../../Components/Navbar";
import { useLocation } from "react-router-dom";
import Clientinfomartion from "./Patientinfoeditscreens/Clientinfomartion";
import Addresses from "./Patientinfoeditscreens/Addresses";
import ClientTeam from "./Patientinfoeditscreens/ClientTeam";
import Consents from "./Patientinfoeditscreens/Consents";
import ClientHistory from "./Patientinfoeditscreens/ClientHistory";
import ClientIdentification from "./Patientinfoeditscreens/ClientIdentification";
import EmergencyContacts from "./Patientinfoeditscreens/EmergencyContacts";
import ClientPayment from "./Patientinfoeditscreens/ClientPayment";
import Notification from "./Patientinfoeditscreens/Notification";
import { Getagencypatientdetails } from "../../../api/helper";
import AddAllergy from "./AddProblemInformationpopups/AddAllergy";
import PatientDocuments from "./AddProblemInformationpopups/PatientDocuments";
import AddLabOrder from "./AddProblemInformationpopups/AddLabOrder";
import NotesTabScreen from "./Patientinfoeditscreens/NotesTabScreen";
import MeasuresTabScreen from "./Patientinfoeditscreens/MeasuresTabScreen";
import ProblemsScreen from "./Patientinfoeditscreens/ProblemsScreen";
import Medicationsagency from "./AddProblemInformationpopups/Medicationsagency";
import Vitals from "./AddProblemInformationpopups/Vitals";
import { setPatinetDetails } from "../../../redux/cookiesReducer";
import { useDispatch } from "react-redux";
import PatientJourneyAgency from "./PatientJourneyAgency";
import VisitsPatientdetails from "./VisitsPatientdetails";
import CreateAppointment from "./AppointmetCalander/CreateAppointment";

const ClientEditbyagency = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");
  const tab = queryParams.get("tab");
  const [patientid, setpatientid] = useState(
    id ? id : location.state.data?._id
  );

  const dispatch = useDispatch();
  const [info, setInfo] = useState(null);
  const [activeTab, setActiveTab] = useState(tab ? tab : "info");
  const [showAppointmentPanel, setShowAppointmentPanel] = useState(false);
const [moreactionmodal, setmoreactionmodal] = useState(false)
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const getDteails = async () => {
    const response = await Getagencypatientdetails(patientid);
    setInfo(response.data.data);
    dispatch(setPatinetDetails(response.data.data));
  };
  useEffect(() => {
    getDteails();
  }, [patientid]);
  return (
    <div className="dashboard-container">
      <AgencySideBar />
      <div className="dashboard-content">
        <Navbar />
        <div className="dashboard-cards">
          <div className="doctor-details-container">
            <div className="patient-card">
              <div className="header-container">
                <div className="header-row-left">
                  <div className="header_textt">Patient Details</div>
                  <span className="badge-active">Active</span>
                </div>
                <button
                  className="new-visit-btn"
                  id="newVisitBtn"
                  onClick={() => setShowAppointmentPanel(true)}
                >
                  + New Visit
                </button>
              </div>
              <div className="top-section">
                <div className="left-info">
                  <div className="avatar_patient">
                    {/* <i className="fas fa-user" /> */}
                    {info && info?.patientId?.image ? (
                      <img
                        className="doctor-image"
                        src={info?.patientId?.image}
                        alt="Patient Image"
                      />
                    ) : (
                      <i className="fas fa-user" />
                    )}
                  </div>
                  <div className="details_patient">
                    <div className="details-header">
                      <h2>
                        {" "}
                        {info &&
                          info?.patientId?.firstName +
                            " " +
                            info?.patientId?.lastName}
                      </h2>

                      <div className="shortcut-icons">
                        <div className="icon-group">
                          <div
                            className="icon-button portal-toggle active"
                            id="togglePortal"
                            title="Deactivate Patient Portal"
                          >
                            <i className="fas fa-toggle-on" />
                            <span className="tooltiptext">Patient Portal</span>
                          </div>
                          <div
                            className="icon-button"
                            id="editProfile"
                            title="Edit Profile"
                          >
                            <i className="fas fa-edit" />
                            <span className="tooltiptext">Edit Profile</span>
                          </div>
                          <div
                            className="icon-button"
                            id="sendMessage"
                            title="Message Patient"
                          >
                            <i className="fas fa-comment-dots" />
                            <span className="tooltiptext">Message</span>
                          </div>
                        </div>
                        {/* Clinical Actions Icons */}
                        <div className="icon-group">
                          <div
                            className="icon-button"
                            id="addNote"
                            title="Add Note"
                          >
                            <i className="fas fa-sticky-note" />
                            <span className="tooltiptext">Add Note</span>
                          </div>
                          <div
                            className="icon-button"
                            id="aiNote"
                            title="AI-Assisted Note"
                          >
                            <i className="fa fa-star"></i>

                            <span className="tooltiptext">
                              AI-Assisted Note
                            </span>
                          </div>
                          <div
                            className="icon-button"
                            id="viewCarePlan"
                            title="View Care Plan"
                          >
                            <i className="fas fa-notes-medical" />
                            <span className="tooltiptext">View Care Plan</span>
                          </div>
                        </div>
                        <div className="icon-group">
                          <div
                            className="icon-button"
                            id="scheduleVisit"
                            title="Schedule Visit"
                          >
                            <i className="fas fa-calendar-plus" />
                            <span className="tooltiptext">Schedule Visit</span>
                          </div>

                          <div
                            className="icon-button"
                            id="joinTelehealth"
                            title="Join Telehealth"
                            style={{ display: "flex" }}
                          >
                            <i className="fas fa-video" />
                            <span className="tooltiptext">Join Telehealth</span>
                            <div className="countdown" id="telehealthTimer">
                              Now
                            </div>
                          </div>
                          <div
                            className="icon-button"
                            id="sendReminder"
                            title="Send Reminder"
                          >
                            <i className="fas fa-bell" />
                            <span className="tooltiptext">Send Reminder</span>
                          </div>
                        </div>
                        <div className="icon-group more-actions">
                          <div
                            className="icon-button"
                            id="moreToggle"
                            title="More Actions"
                            onClick={()=>{setmoreactionmodal(true)}}
                          >
                            <i className="fas fa-ellipsis-h" />
                            <span className="tooltiptext">More Actions</span>
                          </div>
                          {moreactionmodal &&
                            <div className="more-dropdown" id="moreMenu">
                           
                            <div className="dropdown-section-label" >
                              Billing
                            </div>
                            <div
                              className="dropdown-item_patient"
                              id="checkEligibility"
                                onClick={()=>{setmoreactionmodal(false)}}
                            >
                              <i className="fas fa-clipboard-check" /> Insurance
                              Check
                            </div>
                            <div
                              className="dropdown-item_patient"
                              id="createClaim"
                               onClick={()=>{setmoreactionmodal(false)}}
                            >
                              <i className="fas fa-file-invoice-dollar" />{" "}
                              Create Claim
                            </div>
                            {/* ── Forms & Referrals Section ── */}
                            <div className="dropdown-section-label">
                              Forms &amp; Referrals
                            </div>
                            <div
                              className="dropdown-item_patient"
                              id="sendForm"
                               onClick={()=>{setmoreactionmodal(false)}}
                            >
                              <i className="fas fa-file-signature" /> Send Form
                            </div>
                            <div
                              className="dropdown-item_patient"
                              id="createReferral"
                               onClick={()=>{setmoreactionmodal(false)}}
                            >
                              <i className="fas fa-handshake" /> Create Referral
                            </div>
                            {/* ── Documents & Messaging Section ── */}
                            <div className="dropdown-section-label">
                              Documents &amp; Messaging
                            </div>
                            <div
                              className="dropdown-item_patient"
                              id="uploadDocument"
                               onClick={()=>{setmoreactionmodal(false)}}
                            >
                              <i className="fas fa-upload" /> Upload Document
                            </div>
                            <div
                              className="dropdown-item_patient"
                              id="printSummary"
                               onClick={()=>{setmoreactionmodal(false)}}
                            >
                              <i className="fas fa-print" /> Print Summary
                            </div>
                            <div
                              className="dropdown-item_patient"
                              id="sendMessageAlt"
                               onClick={()=>{setmoreactionmodal(false)}}
                            >
                              <i className="fas fa-comment-dots" /> Message
                            </div>
                         
                            <div className="dropdown-section-label">
                              Lab &amp; Rx
                            </div>
                            <div
                              className="dropdown-item_patient"
                              id="viewLabResults"
                               onClick={()=>{setmoreactionmodal(false)}}
                            >
                              <i className="fas fa-vials" /> Lab Results
                            </div>
                            <div
                              className="dropdown-item_patient"
                              id="orderRefill"
                               onClick={()=>{setmoreactionmodal(false)}}
                            >
                              <i className="fas fa-pills" /> Refill Medication
                            </div>
                          </div>
                          }
                        
                        </div>
                      </div>
                    </div>
                    <div className="left-col">
                      <p>
                        <strong>Client ID:</strong> {info?.patientId?.uniqueId}
                      </p>
                      <p>
                        <strong>Gender:</strong> {info?.patientId?.gender}
                      </p>
                      <p>
                        <strong>Emergency Contact:</strong>{" "}
                        {info?.EmergencyContactNumber}
                      </p>
                      <p>
                        <strong>Address:</strong>{" "}
                        {info?.patientId?.address?.street +
                          "," +
                          info?.patientId?.address?.city +
                          "," +
                          info?.patientId?.address?.state +
                          "," +
                          info?.patientId?.address?.country}
                      </p>
                    </div>
                    <div className="right-col">
                      <p>
                        <strong>Dob | Age:</strong>{" "}
                        {(() => {
                          const dobString = info?.DOB || "";
                          if (!dobString) return "";
                          const dobDate = new Date(dobString.split("T")[0]);
                          const today = new Date();
                          let age = today.getFullYear() - dobDate.getFullYear();
                          const monthDiff =
                            today.getMonth() - dobDate.getMonth();
                          const dayDiff = today.getDate() - dobDate.getDate();
                          if (
                            monthDiff < 0 ||
                            (monthDiff === 0 && dayDiff < 0)
                          ) {
                            age--;
                          }
                          return `${
                            dobDate.toISOString().split("T")[0]
                          } | ${age} years`;
                        })()}
                      </p>
                      <p>
                        <strong>Primary Contact:</strong>{" "}
                        {info?.patientId?.phone}
                      </p>
                      <p>
                        <strong>Payment Method:</strong>{" "}
                        {info?.PaymentSourcesId?.name}
                      </p>
                      <p>
                        <strong>Email Address:</strong>{" "}
                        {info?.patientId?.email || info?.email}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="tab-section__react">
              <div className="nav-tabs__react">
                {[
                  { key: "info", icon: "fas fa-user", label: "Demographics" },
                  {
                    key: "Addresses",
                    icon: "fas fa-map-marker-alt",
                    label: "Addresses",
                  },
                  {
                    key: "Payment",
                    icon: "fas fa-credit-card",
                    label: "Payment",
                  },
                  {
                    key: "Notification",
                    icon: "fas fa-bell",
                    label: "Notification",
                  },
                  {
                    key: "EmergencyContacts",
                    icon: "fas fa-phone",
                    label: "Emergency Contacts",
                  },
                  {
                    key: "Identification",
                    icon: "fas fa-id-card",
                    label: "Identification",
                  },
                  { key: "History", icon: "fas fa-history", label: "History" },
                  {
                    key: "Consents",
                    icon: "fas fa-file-signature",
                    label: "Consents",
                  },
                  { key: "Team", icon: "fas fa-users", label: "Team" },
                  {
                    key: "AddAllergy",
                    icon: "fas fa-notes-medical",
                    label: "Allergy",
                  },
                  {
                    key: "PatientDocuments",
                    icon: "fas fa-folder",
                    label: "Patient Documents",
                  },
                  {
                    key: "AddLabOrder",
                    icon: "fas fa-vials",
                    label: "Lab Order",
                  },
                  {
                    key: "Medications",
                    icon: "fas fa-pills",
                    label: "Medications",
                  },
                  {
                    key: "Notes",
                    icon: "fas fa-file-medical-alt",
                    label: "Notes",
                  },
                  {
                    key: "MeasuresTabScreen",
                    icon: "fas fa-ruler-combined",
                    label: "Measures",
                  },
                  { key: "Problems", icon: "fas fa-bug", label: "Problems" },
                  { key: "Vitals", icon: "fas fa-heartbeat", label: "Vitals" },
                  {
                    key: "PatientJourney",
                    icon: "fas fa-user-clock",
                    label: " Patient Journey",
                  },
                  {
                    key: "Visits",
                    icon: "fas fa-calendar-check",
                    label: "Visits",
                  },
                ].map((tab) => (
                  <div
                    key={tab.key}
                    className={`nav-pill__react ${
                      activeTab === tab.key ? "active__react" : ""
                    }`}
                    onClick={() => handleTabClick(tab.key)}
                  >
                    <i className={tab.icon}></i> {tab.label}
                  </div>
                ))}
              </div>
            </div>

            {activeTab === "Visits" && info && (
              <VisitsPatientdetails info={info} getDteails={getDteails} />
            )}
            {activeTab === "info" && info && (
              <Clientinfomartion info={info} getDteails={getDteails} />
            )}
            {activeTab === "PatientJourney" && info && <PatientJourneyAgency />}

            {activeTab === "Addresses" && info && (
              <Addresses info={info} getDteails={getDteails} />
            )}
            {activeTab === "Payment" && info && (
              <ClientPayment info={info} getDteails={getDteails} />
            )}
            {activeTab === "Notification" && info && (
              <Notification info={info} getDteails={getDteails} />
            )}
            {activeTab === "EmergencyContacts" && info && (
              <EmergencyContacts info={info} getDteails={getDteails} />
            )}
            {activeTab === "Identification" && info && (
              <ClientIdentification info={info} getDteails={getDteails} />
            )}
            {activeTab === "History" && info && (
              <ClientHistory info={info} getDteails={getDteails} />
            )}
            {activeTab === "Consents" && info && (
              <Consents info={info} getDteails={getDteails} />
            )}
            {activeTab === "Team" && info && (
              <ClientTeam info={info} getDteails={getDteails} />
            )}
            {activeTab === "AddAllergy" && info && <AddAllergy info={info} />}
            {activeTab === "PatientDocuments" && info && (
              <PatientDocuments info={info} />
            )}
            {activeTab === "Notes" && info && <NotesTabScreen info={info} />}
            {activeTab === "MeasuresTabScreen" && info && (
              <MeasuresTabScreen info={info} />
            )}
            {activeTab === "Problems" && info && <ProblemsScreen info={info} />}
            {activeTab === "AddLabOrder" && info && <AddLabOrder info={info} />}
            {activeTab === "Medications" && info && (
              <Medicationsagency info={info} />
            )}
            {activeTab === "Vitals" && info && <Vitals info={info} />}
          </div>
          <div
            className={`appointment-panel_CalendarView ${
              showAppointmentPanel ? "show" : ""
            }`}
          >
            <CreateAppointment
              info={info}
              setShowAppointmentPanel={setShowAppointmentPanel}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientEditbyagency;
